
import { AxiosError } from 'axios';
import { IApiErrors, IUpdatedProposition } from '../../context/model';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, createSearchParams } from 'react-router-dom';
import * as Yup from 'yup';
import StickButtonsBloc from '../../blocs/common/StickButtonsBloc';
import { APP_URLS } from '../../const/AppConst';
import useAppState from '../../context/AppContext';
import { IAdditionalData } from '../../context/model/index';
import { useFetchNomenclature } from '../../hooks/useFetchNomenclature';
import { isPropositionInDraft, isDoneProposition, isCompletedProposition, isConfirmedContactProposition } from '../../utils/dataUtils';
import RecapElement from '../recap/RecapElement';
import moment from 'moment';
import RecapInfoBancaireFormComponent from '../recap/RecapInfoBancaireFormComponent';
import LoaderModal from '../../modals/common/LoaderModal';
import ConfirmModal from '../../modals/common/ConfirmModal';
import { updatePropositionContact } from '../../services/CustomerApiService';
import MgpMessage from '../../elements/MgpMessage/MgpMessage';
import ButtonModifyRecapInfo from '../common/ButtonModifyRecapInfo';
import { cleanSpecialCharAddress, formattedNir, getDayDifferent } from '../../utils/utils';


type InfoPersoRecapFormData = {

}

export default function InfoPersoRecapFormComponent() {

  const {
    state: { jwtToken, proposition, updatedProposition, additionalData, isConseiller, signedDocument, socialSecurityDocuments },
    dispatch,
  } = useAppState();
  const isBeneficiaryGuaranty = proposition?.configuration.canBeAddedBeneficiaries && proposition?.configuration.hasOfferStep;

  const validationSchema = Yup.object().shape({

  });
  
  const navigate = useNavigate();

  const [errorMsg, setErrorMsg] = useState<string | null>();
  const [loading, setLoading] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);
  const [departmentLabel, setDepartmentLabel] = useState<string | null>();
  const [familySituationLabel, setFamilySituationLabel] = useState<string | null>();
  const [countryLabel, setCountryLabel] = useState<string | null>();

  const showConfirmationModal = () => {
    if (isConfirmedContactProposition(proposition!)) {
      let nextUrl = APP_URLS.recapPage;
      if (proposition?.configuration.canBeAddedBeneficiaries) {
        nextUrl = APP_URLS.infoBeneficiaryStep0Page;
      } else if(proposition?.configuration.hasOfferStep) {
        nextUrl = APP_URLS.guarantyPage;
      } else if(proposition?.configuration.hasPreviousInsuranceTermination && getDayDifferent(proposition?.effectiveDate) > 32) {
        nextUrl = APP_URLS?.infoOldContractPage;
      }
      dispatch({type: 'NEXT_INFO_STEP', path: nextUrl});
      navigate({
        pathname: nextUrl,
        search: `?id=${proposition!.propositionId}`,
      });
    } else {
      if (socialSecurityDocuments.findIndex(doc => doc.name === "Attestation de droits") === -1) {
        setErrorMsg("Merci de joindre votre attestation de droits à l'assurance maladie.")
      } else {
        setIsShowModal(true);
      }
    }
  }
  const closeModal = () => {
    setIsShowModal(false)
  }

  const familySituationNomenclature = useFetchNomenclature("familySituation");
  const departmentNomenclature = useFetchNomenclature("department", true);
  const countryNomenclature = useFetchNomenclature("country", true);

  const {
    handleSubmit
  } = useForm<InfoPersoRecapFormData>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
    },
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    if(familySituationNomenclature && updatedProposition?.familySituationCode) {
      setFamilySituationLabel(`${familySituationNomenclature.options?.find(el => el.code === updatedProposition?.familySituationCode)?.label}`);
    }
    if(departmentNomenclature && updatedProposition?.departmentCode) {
      setDepartmentLabel(`${updatedProposition!.departmentCode} - ${departmentNomenclature.options?.find(d => d.code === updatedProposition.departmentCode)?.label}`);
    }
    if(countryNomenclature && updatedProposition?.countryId){
      setCountryLabel(`${countryNomenclature.options?.find(el => el.code === updatedProposition?.countryId)?.label}`)
    }
  }, [familySituationNomenclature, departmentNomenclature, countryNomenclature]);
 
  const onNextAction = async (data: InfoPersoRecapFormData) => {
    let tempUpdatedPropo = {
      ...updatedProposition,
      address: cleanSpecialCharAddress(updatedProposition?.address ?? ""),
      city: cleanSpecialCharAddress(updatedProposition?.city ?? ""),
      lieudit: cleanSpecialCharAddress(updatedProposition?.lieudit ?? ""),
      additionalAddress: cleanSpecialCharAddress(updatedProposition?.additionalAddress ?? ""),
      buildingName: cleanSpecialCharAddress(updatedProposition?.buildingName ?? "")
    } as IUpdatedProposition;
    let tempAdditionalData = additionalData ?? {} as IAdditionalData;

    setLoading(true);
    setErrorMsg('');
    if(tempUpdatedPropo) {
      try {
        const token = jwtToken!.accessToken;
        
        if (tempUpdatedPropo.protectedAddress) {
            tempUpdatedPropo.address = "";
            tempUpdatedPropo.postalCode = "";
            tempUpdatedPropo.city = "";
            tempUpdatedPropo.lieudit = "";
            tempUpdatedPropo.additionalAddress = "";
            tempUpdatedPropo.buildingName = "";
        }

        const res = await updatePropositionContact(token, proposition!.propositionId, tempUpdatedPropo);
        setLoading(false);
        let nextUrl = APP_URLS.infoBeneficiaryStep0Page;
        if (!proposition?.configuration.canBeAddedBeneficiaries) {
          nextUrl = APP_URLS.guarantyPage;
        } 
        
        dispatch({type: 'NEXT_INFO_STEP', path: nextUrl, updatedProposition: tempUpdatedPropo, additionalData: tempAdditionalData, proposition: res.data});
        navigate({
          pathname: nextUrl,
          search: `?id=${proposition!.propositionId}`,
        });
      } catch (error) {
        setLoading(false);
        setIsShowModal(false);
        const err = error as AxiosError;
        console.log(err);
        if(err.response && err.response.status === 400) {
          const errorData = err.response?.data as IApiErrors;
          setErrorMsg("Erreur: " + errorData.message);
        } else {
          setErrorMsg("Une erreur technique est survenue ");
        }
      }
    }
  }

  const onNextLockedAction =  () => {
    closeModal();
    setErrorMsg(null);
    let nextUrl = APP_URLS.endPage;
    let replaceUrl = false;
    let hasSignature = proposition?.configuration.hasSignature;
    if(isDoneProposition(proposition!)) {
      if(hasSignature && signedDocument.length > 0) {
        nextUrl = APP_URLS.infoSignatureStep2Page;
      } else {
        nextUrl = APP_URLS.listInvalidDocumentPage;
      }
    } else if(isCompletedProposition(proposition!)) {
      if(hasSignature) {
        nextUrl = APP_URLS.infoSignatureStep0Page;
        replaceUrl = true;
      }
    }
    dispatch({type: 'NEXT_INFO_STEP', path: nextUrl});
    
    navigate({
      pathname: nextUrl,
      search: createSearchParams({
          id: proposition!.propositionId
      }).toString(),
    }, {replace: replaceUrl});
  }

  const onPreviousAction = () => {
    let backUrl = APP_URLS.infoPersoStep5Page;
    // let backUrl = APP_URLS.infoPersoStep6Page;
    if(proposition?.configuration.hasSalaryStep){
      backUrl = APP_URLS.infoPersoStep7Page;
    } 
    else if(proposition?.configuration.hasIdentityUploadStep) {
      backUrl = APP_URLS.infoPersoStep6Page;
    }
    dispatch({type: 'BACK_INFO_STEP', path: backUrl});
    navigate({
      pathname: backUrl,
      search: `?id=${proposition!.propositionId}`,
    });
  }

    return (            
      <form style={{width: '100%'}}>

        {errorMsg && <MgpMessage type="danger" message={errorMsg} hasCloseBtn={true}/>}
          
        <div className='form-row page-content'>          
          <div className='col-flex-4'>
              <div className="flex-grid bg-blanc shadow-noir p-md mb-lg recap-content">
                <div className="grid-flex wrapper-edition ">
                    <h2 className="card-title bleu mb-sm">
                        Mon identité
                    </h2>

                    <ButtonModifyRecapInfo 
                        isDisplayed={proposition && isPropositionInDraft(proposition) && (!isConfirmedContactProposition(proposition!) || !isBeneficiaryGuaranty)}
                        handleClick={ () => navigate({ pathname: APP_URLS.infoPersoStep1Page, search: `?id=${proposition!.propositionId}`, }) }
                    />

                </div>  
                <div>
                    <div className="form-row">      
                        <div className="form-group mw-50">
                            <RecapElement id='civilityLabel' label='Civilité' value={`${proposition!.contact.civilityLabel}`} />
                        </div>
                        <div className="form-group mw-50">
                          <RecapElement id='familySituationLabel' label='Situation familiale' value={`${familySituationLabel}`} />
                        </div>
                    </div>

                    <div className='form-row'>
                        <div className="form-group mw-50">
                          <RecapElement id='lastName' label='Nom' value={`${proposition!.contact.lastName}`} />
                        </div>
                        <div className="form-group mw-50">
                          <RecapElement id='firstName' label='Prénom' value={`${updatedProposition?.firstName}`} />
                        </div>
                    </div>

                    {updatedProposition?.birthName && 
                      <div className='form-row'>
                        <div className="form-group">
                          <RecapElement id='birthName' label='Nom de naissance' value={`${updatedProposition?.birthName}`}/>
                        </div>
                      </div>
                    }

                    <div className="form-row">      
                        <div className="form-group mw-50">
                            <RecapElement id='birthDate' label='Date de naissance' value= {proposition!.contact.birthDate ? moment(proposition!.contact.birthDate).format("DD/MM/YYYY") : ""} />
                          
                        </div>
                        <div className="form-group mw-50">
                            <RecapElement id='birthPlace' label='Lieu de naissance' value={`${updatedProposition!.birthPlace}`} />
                        </div> 
                    </div>

                    
                </div>
            </div>

            <RecapInfoBancaireFormComponent modifyUrl={APP_URLS.infoPersoStep4Page}/>

            
            <div className="flex-grid bg-blanc shadow-noir p-md mb-lg recap-content">
              <div className="grid-flex wrapper-edition ">
                  <h2 className="card-title bleu mb-sm">
                      Mes modalités de contact
                  </h2>

                  <ButtonModifyRecapInfo 
                        isDisplayed={proposition && isPropositionInDraft(proposition) && (!isConfirmedContactProposition(proposition!) || !isBeneficiaryGuaranty)}
                        handleClick={ () => navigate({ pathname: APP_URLS.infoPersoStep5Page, search: `?id=${proposition!.propositionId}`, }) }
                  />

              </div>  
              <div>
                  <div className="form-row">      
                      <div className="form-group mw-100">
                          <RecapElement id='email' label='Email' value={`${updatedProposition!.email}`} />
                      </div>
                  </div>
                  <div className='form-row'>
                      <div className="form-group mw-100">
                          <RecapElement id='phoneNumber' label='Téléphone' value={updatedProposition!.phoneNumber && !updatedProposition!.isForeignMobile ?`${updatedProposition!.phoneNumber?.replace(/[^\dA-Z]/g, '').replace(/(.{2})/g, '$1 ').trim()}` : `${updatedProposition!.phoneNumber?.trim()}`} />
                      </div>
                  </div>
              </div>          
            </div>
          </div>
          
          <div className='col-flex-4'>
            
            <div className="flex-grid bg-blanc shadow-noir p-md mb-lg recap-content">
              <div className="grid-flex wrapper-edition ">
                  <h2 className="card-title bleu mb-sm">
                      Mes informations de santé
                  </h2>

                  <ButtonModifyRecapInfo 
                      isDisplayed={proposition && isPropositionInDraft(proposition) && (!isConfirmedContactProposition(proposition!) || !isBeneficiaryGuaranty)}
                      handleClick={ () => navigate({ pathname: APP_URLS.infoPersoStep3Page, search: `?id=${proposition!.propositionId}`, }) }
                  />

              </div>  
              <div>
                  <div className="form-row">      
                      <div className="form-group mw-100">
                          <RecapElement id='nir' label='Numéro de sécurité sociale' value={`${proposition!.contact.nir ? formattedNir(proposition!.contact.nir) : ""} ${proposition!.contact.nirKey}`}  />
                      </div>
                  </div>
                  <div className='form-row'>
                    <div className="form-group mw-100">
                      <RecapElement id='regimeCode' label='Organisme de rattachement' value={`${updatedProposition!.attachmentOrganization ? updatedProposition!.attachmentOrganization.replace(/(\d{2})(\d{3})(\d{4})/, '$1 $2 $3').trim() : ''} `} />
                    </div>
                  </div>
              </div> 
            </div>

            <div className="flex-grid bg-blanc shadow-noir p-md mb-lg recap-content">
              <div className="grid-flex wrapper-edition ">
                  <h2 className="card-title bleu mb-sm">
                      Mon adresse
                  </h2>
                  <ButtonModifyRecapInfo 
                        isDisplayed={proposition && isPropositionInDraft(proposition) && (!isConfirmedContactProposition(proposition!) || !isBeneficiaryGuaranty)}
                        handleClick={ () => navigate({ pathname: APP_URLS.infoPersoStep2Page, search: `?id=${proposition!.propositionId}`, }) }
                  />
              </div>  
             
              {
                  updatedProposition?.protectedAddress ?
                  <div className="form-row">      
                      <div className="form-group mw-100 flex va-center jc-start">
                        <div>
                          <RecapElement id='department' label='Votre department' value={`${departmentLabel}`} />
                        </div>
                        <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + `/img/picto_MGProtect_Localisation.svg`} alt='MGPROTECT Localisation' width={60}/>
                      </div>
                  </div>
                  :  
                  <div>
                    {updatedProposition!.additionalAddress &&
                      <div className='form-row'>
                        <div className="form-group mw-100">
                            <RecapElement id='additionalAddress' label='Complément du nom' value={`${updatedProposition!.additionalAddress}`} />
                        </div>
                      </div>
                    }

                    {updatedProposition!.buildingName &&
                      <div className='form-row'>
                        <div className="form-group mw-100">
                            <RecapElement id='buildingName' label='Résidence et bâtiment' value={`${updatedProposition!.buildingName}`} />
                        </div>
                      </div>
                    }

                    <div className="form-row">      
                      <div className="form-group mw-100">
                          <RecapElement id='address' label='Numéro et libellé de la voie' value={`${updatedProposition!.address}`} />
                      </div>
                    </div>
                    {updatedProposition!.lieudit &&
                      <div className='form-row'>
                        <div className="form-group mw-100">
                            <RecapElement id='lieudit' label='Lieu-dit, Hameau, Commune, BP' value={`${updatedProposition!.lieudit}`} />
                        </div>
                      </div>}
                    <div className='form-row'>
                      <div className="form-group mw-100">
                          <RecapElement id='address' label='Ville et Code postal' value={`${updatedProposition!.postalCode} ${updatedProposition!.city}`} />
                      </div>
                    </div>
                    <div className='form-row'>
                      <div className="form-group mw-100">
                          <RecapElement id='country' label='Pays' value={`${countryLabel}`} />
                      </div>
                    </div>
                  </div> 
              }
        
            </div>
            {proposition?.configuration.hasSalaryStep &&                                                                                                     
              <div className="flex-grid bg-blanc shadow-noir p-md mb-lg recap-content">
                <div className="grid-flex wrapper-edition ">
                    <h2 className="card-title bleu mb-sm">
                        Ma cotisation
                    </h2>

                    <ButtonModifyRecapInfo
                        isDisplayed={proposition && isPropositionInDraft(proposition) && (!isConfirmedContactProposition(proposition!) || !isBeneficiaryGuaranty)}
                        handleClick={ () => navigate({ pathname: APP_URLS.infoPersoStep7Page, search: `?id=${proposition!.propositionId}`, }) }
                    />

                </div>  
             
                <div className="form-row">      
                    <div className="form-group mw-100">
                        <RecapElement id='nir' label='Indiciaire brut mensuel' value={`${updatedProposition!.salaryIndex??''}`}  />
                    </div>
                    <div className="form-group mw-100">
                        <RecapElement id='regimeCode' label='Indice majoré' value={`${updatedProposition!.increasedIndex??''}`} />
                    </div>
                </div>

              </div>
            }
            
          </div>
        
        </div>
         {isPropositionInDraft(proposition!) ? ( <StickButtonsBloc disabledPreviousButton={false} showNextButton={true} showPreviousButton={!isConfirmedContactProposition(proposition!)} previousAction={onPreviousAction} nextAction={showConfirmationModal} nextButtonName={isConfirmedContactProposition(proposition!) ? "Suivant" : "Confirmer"}/>) 
        : ( <StickButtonsBloc showNextButton={true} showPreviousButton={isConseiller} previousAction={onPreviousAction} nextAction={onNextLockedAction} />)}
       
       {loading && <LoaderModal hasMessage={true}/>}
        <ConfirmModal isOpen={isShowModal} onConfirmAction={handleSubmit(onNextAction)} onCloseModal={closeModal} text={<p className='ta-center bleu fz-lg fw-bold'>Nous vous invitons à vérifier l'exactitude des informations saisies. Passé cette étape, il ne sera plus possible de les modifier.</p>} />
      </form>
  )
}
